/** @format */

import {styled} from '@mui/material/styles';
import {Typography, TypographyProps} from '@mui/material';

const StyledTypography = styled(Typography)(() => ({
  fontSize: 24,
  fontWeight: 700,
  lineHeight: '30px',
}));

const Title = (props: TypographyProps) => <StyledTypography {...props} />;

export default Title;
